export default {
  province_list: [
    { 
      text: 'Lusaka', 
      value: 1,
      cities: [
        { text: 'Chilanga', value: 1 },
        { text: 'Chirundu', value: 2 },
        { text: 'Chongwe', value: 3 },
        { text: 'Kafue', value: 4 },
        { text: 'Luangwa', value: 5 },
        { text: 'Lusaka', value: 6 },
        { text: 'Rufunsa', value: 7 }
      ]
    },
    { 
      text: 'Copperbelt', 
      value: 2,
      cities: [
        { text: 'Chililabombwe', value: 1 },
        { text: 'Chingola', value: 2 },
        { text: 'Kalulushi', value: 3 },
        { text: 'Kitwe', value: 4 },
        { text: 'Luanshya', value: 5 },
        { text: 'Lufwanyama', value: 6 },
        { text: 'Masaiti', value: 7 },
        { text: 'Mpongwe', value: 8 },
        { text: 'Mufulira', value: 9 },
        { text: 'Ndola', value: 10 },
        { text: 'Chambishi', value: 11 },
      ]
    },
    { 
      text: 'Southern', 
      value: 3,
      cities: [
        { text: 'Choma', value: 1 },
        { text: 'Gwembe', value: 2 },
        { text: 'Kalomo', value: 3 },
        { text: 'Kazungula', value: 4 },
        { text: 'Livingstone', value: 5 },
        { text: 'Mazabuka', value: 6 },
        { text: 'Monze', value: 7 },
        { text: 'Namwala', value: 8 },
        { text: 'Siavonga', value: 9 },
        { text: 'Sinazongwe', value: 10 },
      ]
    },
    {
       text: 'Western', 
       value: 4,
       cities: [
        { text: 'Kalabo', value: 1 },
        { text: 'Kaoma', value: 2 },
        { text: 'Limulunga', value: 3 },
        { text: 'Luampa', value: 4 },
        { text: 'Lukulu', value: 5 },
        { text: 'Mitete', value: 6 },
        { text: 'Mongu', value: 7 },
        { text: 'Mulobezi', value: 8 },
        { text: 'Mwandi', value: 9 },
        { text: 'Nalolo', value: 10 },
        { text: 'Nkeyama', value: 11 },
        { text: 'Senanga', value: 12 },
        { text: 'Sesheke', value: 13 },
        { text: 'Shangombo', value: 14 },
        { text: 'Sikongo', value: 15 },
        { text: 'Sioma', value: 16 }
      ]
    },
    { 
      text: 'Eastern', 
      value: 5,
      cities: [
        { text: 'Chadiza', value: 1 },
        { text: 'Chasefu', value: 2 },
        { text: 'Chipangali', value: 3 },
        { text: 'Chipata', value: 4 },
        { text: 'Kasenengwa', value: 5 },
        { text: 'Katete', value: 6 },
        { text: 'Lumezi', value: 7 },
        { text: 'Lundazi', value: 8 },
        { text: 'Mambwe', value: 9 },
        { text: 'Lusangazi', value: 10 },
        { text: 'Nyimba', value: 11 },
        { text: 'Petauke', value: 12 },
        { text: 'Sinda', value: 13 },
        { text: 'Vubwi', value: 14 },
      ]
    },
    { 
      text: 'Northern', 
      value: 6,
      cities: [
        { text: 'Chilubi', value: 1 },
        { text: 'Kaputa', value: 2 },
        { text: 'Kasama', value: 3 },
        { text: 'Lunte', value: 4 },
        { text: 'Lupososhi', value: 5 },
        { text: 'Luwingu', value: 6 },
        { text: 'Mbala', value: 7 },
        { text: 'Mporokosa', value: 8 },
        { text: 'Mpulungu', value: 9 },
        { text: 'Mungwi', value: 10 },
        { text: 'Nsama', value: 11 },
        { text: 'Senga', value: 12 }
      ]
    },
    { 
      text: 'Luapula', 
      value: 7,
      cities: [
        { text: 'Chembe', value: 1 },
        { text: 'Chiengi', value: 2 },
        { text: 'Chifunabuli', value: 3 },
        { text: 'Chipili', value: 4 },
        { text: 'Kawambwa', value: 5 },
        { text: 'Lunga', value: 6 },
        { text: 'Mansa', value: 7 },
        { text: 'Milenge', value: 8 },
        { text: 'Mwansabombwe', value: 9 },
        { text: 'Mwense', value: 10 },
        { text: 'Nchelenge', value: 11 },
        { text: 'Samfya', value: 12 }
      ]
    },
    { 
      text: 'North-Western', 
      value: 8,
      cities: [
        { text: 'Chavuma', value: 1 },
        { text: 'Ikelenge', value: 2 },
        { text: 'Kabompo', value: 3 },
        { text: 'Kasempa', value: 4 },
        { text: 'Kalumbila', value: 5 },
        { text: 'Manyinga', value: 6 },
        { text: 'Mufumbwe', value: 7 },
        { text: 'Mushindamo', value: 8 },
        { text: 'Mwinilunga', value: 9 },
        { text: 'Solwezi', value: 10 },
        { text: 'Zambezi', value: 11 },
      ]
    },
    { 
      text: 'Muchinga', 
      value: 9,
      cities: [
        { text: 'Chama', value: 1 },
        { text: 'Chinsali', value: 2 },
        { text: 'Chilindi', value: 3 },
        { text: 'Isoka', value: 4 },
        { text: 'Kanchibiya', value: 5 },
        { text: 'Luvushimanda', value: 6 },
        { text: 'Mafinga', value: 7 },
        { text: 'Mpika', value: 8 },
        { text: 'Nakonde', value: 9 },
        { text: 'Shiwangandu', value: 10 },
      ]
    },
    { 
      text: 'Central', 
      value: 10,
      cities: [
        { text: 'Chibombo', value: 1 },
        { text: 'Chisamba', value: 2 },
        { text: 'Chitambo', value: 3 },
        { text: 'Itezhi-Tezhi', value: 4 },
        { text: 'Kabwe', value: 5 },
        { text: 'Kapiri Mposhi', value: 6 },
        { text: 'Luano', value: 7 },
        { text: 'Mkushi', value: 8 },
        { text: 'Mumbwa', value: 9 },
        { text: 'Ngabwe', value: 10 },
        { text: 'Serenje', value: 11 },
        { text: 'Shibuyunji', value: 12 },
      ]
    }
  ]  
}